import FormFieldViewText from "components/FormFields/ViewText";
import { OriginIntegration } from "types/generated";

import { VCSCheckLabels } from "./helpers";
import VCSIntegrationsUseGitCheckoutInfo from "./UseGitCheckoutInfo";

type VCSIntegrationsDetailsOriginProps = {
  details: OriginIntegration;
};

const VCSIntegrationsDetailsOrigin = ({ details }: VCSIntegrationsDetailsOriginProps) => {
  return (
    <>
      <FormFieldViewText label="Installation target" value={details.installationTarget} />
      <FormFieldViewText label="Repository selection" value={details.repoSelectionMode} />
      <FormFieldViewText label="Scopes" value={details.scopes.join(", ")} />
      <VCSIntegrationsUseGitCheckoutInfo value={details.useGitCheckout} />
      <FormFieldViewText label="VCS checks" value={VCSCheckLabels[details.vcsChecks]} />
    </>
  );
};

export default VCSIntegrationsDetailsOrigin;
